import React from 'react';
import useAssignablesStore from './store/useAssignablesStore';
import AssessmentSelector from './AssignableModels/AssessmentSelector';
import GameSelector from './AssignableModels/GameSelector';
import ReadingAssignablesSelector from './AssignableModels/ReadingAssignablesSelector';
import SlideShowSelector from './AssignableModels/SlideShowSelector';
import InvestigationSelector from './AssignableModels/InvestigationSelector';
import ReferenceMaterialSelector from './AssignableModels/ReferenceMaterialSelector';

interface AssignableModelsSelectorProps {
  form: {
    getState(): () => ({}),
  },
}

const AssignableModelsSelector = ({ form }: AssignableModelsSelectorProps) => {
  const selectedType = useAssignablesStore(state => state.selectedType);
  const libraryTypes = useAssignablesStore(state => state.libraryTypes);

  // Libraries come from content data, so the API tells us which types are libraries rather than
  // this listing them (PLAT-14851).
  if (libraryTypes.includes(selectedType)) return <ReferenceMaterialSelector selectedType={selectedType} />;

  switch (selectedType) {
    case 'assessment':
      return <AssessmentSelector />;
    case 'games':
      return <GameSelector />;
    case 'unitProjects':
    case 'sectionNotebook':
      return <ReadingAssignablesSelector form={form} />;
    case 'videoActivity':
    case 'lessonOutline':
    case 'investigationActivity':
    case 'classroomActivity':
    case 'readingActivity':
    case 'unitSlideshows':
      return <SlideShowSelector form={form} />;
    case 'investigation':
      return <InvestigationSelector form={form} />;
    default:
      return null;
  }
};

export default AssignableModelsSelector;
